var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st161{fill:#FFFFFF;stroke:#010101;stroke-width:3;stroke-miterlimit:10;}\n\t.st160{fill:#FFFFFF;stroke:#010101;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st161",
    d: "M153.49,98.55c-2.38,12.23-5.43,30.15-7.55,51.94c-4.99,51.34-1.32,88.67,1.72,124.52 c1.53,18.13-0.24,41.35,1.54,67.74s3.18,55.64,4.82,90c5.66-0.1,15.78,0.76,21.53,0.33c5.58-0.42,18.02-0.57,23.47-1.33 c-2.94-28.43-8.51-62.66-6.57-98.68c2.78-51.48,8.73-95.81,18.71-131.94c0.11-32.8,0.23-65.59,0.34-98.39 C192.16,101.34,172.83,99.95,153.49,98.55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st161",
    d: "M269.51,98.55c2.38,12.23,5.43,30.15,7.55,51.94c4.99,51.34,1.32,88.67-1.72,124.52 c-1.53,18.13,0.24,41.35-1.54,67.74s-0.15,55.64-1.78,90c-5.66-0.1-18.81,0.76-24.56,0.33c-5.58-0.42-15.99-2.57-21.44-3.33 c2.94-28.43,6.48-60.66,4.53-96.68c-2.78-51.48-8.73-95.81-18.71-131.94c-0.11-32.8-0.23-65.59-0.34-98.39 C230.84,101.34,250.17,99.95,269.51,98.55z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st160",
    points: "162.89,99.51 145.56,155.12 144.79,164.11 166.32,99.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st160",
    points: "259.22,99.51 276.54,155.12 277.32,164.11 255.79,99.64  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st160",
    points: "182.5,101.33 184.17,156.25 186.36,101.33  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st160",
    points: "241.36,101.33 239.68,156.25 237.5,101.33  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "M225.08,100.3v51.66c-0.59,6.39-5.81,11.37-12.17,11.37c-0.48,0-0.95-0.03-1.41-0.09V100.3H225.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "M182.93,91.01c14.82,1.76,29.01,0.03,42.32-0.44c0.09,4.61,0.17,9.22,0.26,13.83 c-6.81,0.5-12.54,0.68-16.75,0.75c-11.14,0.19-24.73,0.36-41.34-2.52c-6.27-1.09-11.4-2.33-14.91-3.27 c1.13-4.19,2.27-8.38,3.4-12.58L182.93,91.01z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.79,
    y: 89.76,
    transform: "matrix(0.9998 0.0211 -0.0211 0.9998 2.1267 -3.7539)",
    className: "st160",
    width: 4.78,
    height: 18.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "st160",
    d: "M241.1,91.01c-14.82,1.76-29.01,0.03-42.32-0.44c-0.77,4.67-0.76,9.27-0.26,13.83 c6.81,0.5,12.54,0.68,16.75,0.75c11.14,0.19,24.73,0.36,41.34-2.52c6.27-1.09,11.4-2.33,14.91-3.27c-1.13-4.19-2.27-8.38-3.4-12.58 L241.1,91.01z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.46,
    y: 89.76,
    transform: "matrix(-0.9998 0.0211 -0.0211 -0.9998 491.7352 192.8854)",
    className: "st160",
    width: 4.78,
    height: 18.55
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleplate);
export default __webpack_public_path__ + "static/media/SINGLE PLATE.eea38e5fc1367deec78c7c4347222300.svg";
export { ForwardRef as ReactComponent };